import { Typography } from "@flash-tecnologia/hros-web-ui-v2";
import styled from "styled-components";

export const EllipsisTitle = styled(Typography)`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
